import { render, staticRenderFns } from "./IPWhitelist.vue?vue&type=template&id=58cf3e5b&"
import script from "./IPWhitelist.vue?vue&type=script&lang=ts&"
export * from "./IPWhitelist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports